import { createReducer, on } from '@ngrx/store';
import {
  getOrdersByMeSuccess,
  changeOrderStatusSuccess,
  getOrdersByCustomerIdSuccess,
  getPendingOrdersSuccess,
} from './order.actions';
import { useCoinsSuccess, getReflexOrdersSuccess, setSelectedOrderSuccess, setSelectedOrderFailure, getReflexOrderByIdSuccess, clearSelectedOrder } from './order.actions';
import {Order} from '../../models/Order';
import {GatewayOrder} from '../../models/GatewayOrder';

export interface OrderState {
  orders: Order[];
  pendingOrders: Order[];
  reflexOrders: GatewayOrder[];
  selectedOrder: Order | null;
  selectedReflexOrder: GatewayOrder | null;
}

export const initialState: OrderState = {
  orders: [],
  pendingOrders: [],
  reflexOrders: [],
  selectedOrder: null,
  selectedReflexOrder: null,
};

export const orderReducer = createReducer(
  initialState,
  on(getOrdersByMeSuccess, (state, { orders }) => ({
    ...state,
    orders: orders,
  })),
  on(getOrdersByCustomerIdSuccess, (state, { orders }) => ({
    ...state,
    orders: orders,
  })),
  on(getPendingOrdersSuccess, (state, { orders }) => ({
    ...state,
    pendingOrders: orders,
  })),
  on(getReflexOrdersSuccess, (state, { orders }) => ({
    ...state,
    reflexOrders: orders,
  })),
  on(getReflexOrderByIdSuccess, (state, { order }) => ({
    ...state,
    selectedReflexOrder: order,
  })),
  on(setSelectedOrderSuccess, (state, { order }) => ({
    ...state,
    selectedOrder: order,
  })),
  on(setSelectedOrderFailure, (state) => ({
    ...state,
    selectedOrder: null,
  })),
  on(useCoinsSuccess, (state, { order }) => ({
    ...state,
    orders: state.orders.map((o) => (o.id === order.id ? order : o)),
    selectedOrder: order,
  })),
  on(changeOrderStatusSuccess, (state, { order }) => ({
    ...state,
    orders: state.orders.map((o) => (o.id === order.id ? order : o)),
    // Remove the order from pendingOrders since it's no longer pending (approved/declined)
    pendingOrders: state.pendingOrders.filter((o) => o.id !== order.id),
  })),
  on(clearSelectedOrder, (state) => ({
    ...state,
    selectedOrder: null,
  })),
);
